export const portsContent = {
  pacific: [
    { name: 'Manzanillo', state: 'Colima', coordinates: '19.1133° N, 104.3414° W', key: 'manzanillo' },
    { name: 'Salina Cruz', state: 'Oaxaca', coordinates: '16.1844° N, 95.2088° W', key: 'salina-cruz' },
    { name: 'Lázaro Cárdenas', state: 'Michoacán', coordinates: '17.9567° N, 102.1944° W', key: 'lazaro-cardenas' },
  ],
  gulf: [
    { name: 'Altamira', state: 'Tamaulipas', coordinates: '22.3964° N, 97.9383° W', key: 'altamira' },
    { name: 'Tampico', state: 'Tamaulipas', coordinates: '22.2553° N, 97.8686° W', key: 'tampico' },
    { name: 'Tuxpan', state: 'Veracruz', coordinates: '20.9597° N, 97.4081° W', key: 'tuxpan' },
    { name: 'Veracruz', state: 'Veracruz', coordinates: '19.1738° N, 96.1342° W', key: 'veracruz' },
    { name: 'Coatzacoalcos', state: 'Veracruz', coordinates: '18.1375° N, 94.4270° W', key: 'coatzacoalcos', isHeadquarter: true },
    { name: 'Pajaritos', state: 'Veracruz', coordinates: '18.1025° N, 94.4240° W', key: 'pajaritos' },
    { name: 'Dos Bocas', state: 'Tabasco', coordinates: '18.2667° N, 93.1833° W', key: 'dos-bocas' },
    { name: 'Cd. del Carmen', state: 'Campeche', coordinates: '18.6500° N, 91.8000° W', key: 'ciudad-del-carmen' },
    { name: 'Progreso', state: 'Yucatán', coordinates: '21.2833° N, 89.6667° W', key: 'progreso' },
  ],
};